export const BRAND = 'EBOOKSTORE™';
export const PRODUCT_NAME = 'MegaPack Charlas de Salud Listas';
export const CHECKOUT_URL = 'https://mega-pack-charlas-de-salud-listas.impultienda.ar/checkout';
export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/8ucnDKhqfNBDBfKuXXsRhh/0046b4cc-e578-4d47-bcf9-39c168e7fd9d.png';
export const PRICE = '$19.990 ARS';
export const CORE_PROMISE = 'Tu próxima charla no empieza desde cero.';
export const CONTACT_EMAIL = 'ebookstore028@gmail.com';

export const quickStats = [
  { value: '5', label: 'Volúmenes completos' },
  { value: '5', label: 'Bonos prácticos' },
  { value: '50+', label: 'Temas para educación en salud' },
  { value: '100', label: 'Actividades educativas' },
];

export const solutionSteps = [
  'Elegís el tema que necesitás.',
  'Encontrás la estructura de la charla.',
  'Sabés cómo empezar, qué explicar, qué preguntar y cómo cerrar.',
  'Tenés actividades para hacer participar al público.',
  'Podés acompañar la exposición con presentaciones y folletos.',
  'Y si solo tenés unos minutos, también contás con material preparado para sala de espera.',
];

export const solutionCycle = ['Elegí', 'Adaptá', 'Presentá'];

export const galleryImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/rNtrNZpX8yS7o3V9ACrPhQ/Captura_de_pantalla_2026-10-08_211620.png',
    alt: 'Charla 07: Prevención del tabaquismo y exposición al humo — ficha con público, duración y objetivo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iWa6AEdCMswsyXd29tDrhH/Captura_de_pantalla_2026-10-08_211719.png',
    alt: 'Banco de 20 preguntas disparadoras reutilizables: inicio, desarrollo y cierre',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/12vpMu941FLfXZAAhd7fMu/Captura_de_pantalla_2026-10-08_211832.png',
    alt: 'Checklist profesional para dar una charla: antes, durante y después',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vrzfgRwyHAYQVDSBEvqfLq/Captura_de_pantalla_2026-10-08_211512.png',
    alt: 'Guion de charla sobre alimentación saludable, paso a paso',
  },
];

export const audienceParagraphs = [
  'MegaPack Charlas de Salud Listas está pensado para médicos, enfermeros, nutricionistas, obstetras, promotores de salud, agentes sanitarios, docentes, instructores, estudiantes avanzados y equipos interdisciplinarios.',
  'También es ideal para quienes trabajan en hospitales, CAPS, consultorios, instituciones educativas y actividades comunitarias.',
];

export const withoutSystem = [
  'Buscar información cada vez.',
  'Organizar el contenido desde cero.',
  'Crear nuevas diapositivas.',
  'Pensar actividades.',
  'Preparar material para entregar.',
  'Improvisar cómo comenzar y cerrar.',
  'Volver a repetir el proceso en la próxima charla.',
];

export const withSystem = [
  'Charlas organizadas.',
  'Guiones preparados.',
  'Presentaciones disponibles.',
  'Folletos educativos.',
  '100 actividades.',
  'Calendario anual.',
  'Microcharlas para sala de espera.',
  'Material reutilizable.',
];

export const faqs = [
  {
    q: '¿Necesito ser médico para utilizar el MegaPack?',
    a: 'No. Está diseñado para diferentes profesionales, docentes, promotores y estudiantes avanzados del área de la salud.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'El producto es 100% digital. Una vez realizada la compra, recibís acceso al material digital correspondiente.',
  },
  {
    q: '¿Puedo adaptar las charlas?',
    a: 'Sí. La idea del sistema es justamente que puedas tomar la estructura preparada y adaptarla según el público, el contexto y tu forma de comunicar.',
  },
  {
    q: '¿Incluye material práctico?',
    a: 'Sí. Además de los volúmenes, recibís presentaciones, folletos, 100 actividades educativas, calendario anual y kit para sala de espera.',
  },
  { q: '¿Los 5 bonos están incluidos?', a: 'Sí. Los 5 bonos forman parte del MegaPack completo.' },
  {
    q: '¿Es un pago único?',
    a: 'Sí. El precio indicado corresponde a un único pago por el acceso digital al sistema.',
  },
];

export const recentBuyers = [
  { name: 'Mariana López', city: 'Córdoba' },
  { name: 'Lucas Fernández', city: 'Rosario' },
  { name: 'Sofía Martínez', city: 'Mendoza' },
  { name: 'Martín Gómez', city: 'La Plata' },
  { name: 'Valeria Díaz', city: 'San Miguel de Tucumán' },
  { name: 'Diego Romero', city: 'Mar del Plata' },
  { name: 'Carolina Sosa', city: 'Salta' },
  { name: 'Federico Álvarez', city: 'Neuquén' },
  { name: 'Lorena Torres', city: 'Santa Fe' },
  { name: 'Pablo Ruiz', city: 'Bahía Blanca' },
  { name: 'Gabriela Benítez', city: 'Posadas' },
  { name: 'Nicolás Herrera', city: 'Buenos Aires' },
  { name: 'Florencia Castro', city: 'Corrientes' },
  { name: 'Javier Medina', city: 'San Juan' },
  { name: 'Natalia Acosta', city: 'Resistencia' },
  { name: 'Sebastián Molina', city: 'Río Cuarto' },
];

export const launchOffer = {
  hours: 17,
};
